/* eslint-disable indent,linebreak-style */
const TABLE_LIMIT = 50;

const tempDate = new Date();

const isProduction = (import.meta?.env?.VITE_APP_ENV || process.env?.REACT_APP_ENV)  === "production";
const apiUrl = import.meta?.env?.VITE_APP_API_URL || process.env?.REACT_APP_API_URL;
const socketUrl = import.meta?.env?.VITE_APP_SOCKET_URL || process.env?.REACT_APP_SOCKET_URL;
const clientToken = import.meta?.env?.VITE_APP_CLIENT_TOKEN || process.env?.REACT_APP_CLIENT_TOKEN;
// const recaptchaSiteKey = import.meta?.env?.VITE_APP_RECAPTCHA_SITE_KEY || process.env?.REACT_APP_RECAPTCHA_SITE_KEY;
const turnstileSiteKey = import.meta?.env?.VITE_APP_TURNSTILE_SITE_KEY || process.env?.REACT_APP_TURNSTILE_SITE_KEY;
const envUploaderUrl = import.meta?.env?.VITE_APP_UPLOADER_URL || process.env?.REACT_APP_UPLOADER_URL;
const payrollUrl = import.meta?.env?.VITE_APP_PAYROLL_URL || process.env?.REACT_APP_PAYROLL_URL;


// Uploader base url comes from app/settings (public_url); env value is only a fallback
const getStoredPublicUrl = () => {
  try {
    const settings = JSON.parse(localStorage?.getItem("app_settings") || "null");
    return settings?.public_url || null;
  } catch (e) {
    return null;
  }
};
let publicUrl = getStoredPublicUrl();

export const setUploaderUrl = (url) => {
  if (url) publicUrl = url;
};

const PROJECT_NAME = 'SKYNET:';
export default {
  isProduction,
  is_development: import.meta?.env?.NODE_ENV === "development" || !isProduction,
  testing_env: import.meta?.env?.REACT_APP_ENV,
  TIME_ZONE: -(tempDate.getTimezoneOffset() / 60),
  DEFAULT_TIME_FORMAT: "DD-MM-YYYY, HH:mm",
  APP_NAME: "IndSwift Panel",
  get UPLOADER_URL() {
    return publicUrl || envUploaderUrl;
  },
  PAYROLL_URL: payrollUrl,
  DEFAULT_APP_URL: apiUrl,
  CLIENT_TOKEN: clientToken,
  // RECAPTCHA_SITE_KEY: recaptchaSiteKey,
  TURNSTILE_SITE_KEY: turnstileSiteKey,
  SOCKET_URL: socketUrl,
  CHAT_API_URL: apiUrl,
  // DEFAULT_APP_URL: 'http://35.154.147.169:5055/api/',
  DEFAULT_PAGE_VALUE: TABLE_LIMIT,
  PAGE_VALUE: 10,
  GOOGLE_LOGIN_KEY:
    "1027293586426-qg6lv2vsp57m05tn32m9stku2ljsd1uh.apps.googleusercontent.com",
  GOOGLE_MAP_KEY: "AIzaSyDUTIV7DaCvMUMg3qElE-sxdj4zR-dxhFM",
  SENTRY_KEY:"https://8c23074c7a1d2532a801cf5f5bb424f7@o4507224995594240.ingest.us.sentry.io/4507225029083136",
  FACEBOOK_LOGIN_KEY: "213504989180156",
  SOCKET_EVENT: {
    EMIT_TEXT_MESSAGE: PROJECT_NAME + 'EMIT_TEXT_MESSAGE',
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
    SEND_ROOM_MESSAGE_UPDATE: PROJECT_NAME + 'SEND_ROOM_MESSAGE_UPDATE',
    UPDATE_MESSAGE_LIST: PROJECT_NAME + 'UPDATE_MESSAGE_LIST',
    UPDATE_JOB_DATA: PROJECT_NAME + 'UPDATE_JOB_DATA',
    DISABLE_ROOM_MESSAGE_UPDATE: PROJECT_NAME + 'DISABLE_ROOM_MESSAGE_UPDATE',
    ENABLE_ROOM_MESSAGE_UPDATE: PROJECT_NAME+'ENABLE_ROOM_MESSAGE_UPDATE',
    INDIVIDUAL_MESSAGE_CHANNEL: PROJECT_NAME+'INDIVIDUAL_MESSAGE_CHANNEL'
  },
  SOCKET_CHANNELS: {
    NEW_MESSAGE: PROJECT_NAME+'NEW_MESSAGE',
    NEW_CONVERSATION: PROJECT_NAME+'NEW_CONVERSATION',
    CONVERSATION_DELETE: PROJECT_NAME+'CONVERSATION_DELETE',
    INDIVIDUAL_MESSAGE_CHANNEL: PROJECT_NAME+'INDIVIDUAL_MESSAGE_CHANNEL'
  },
  DATATABLE_PROPERTIES: {
    title: "Search",
    height: "auto",
    selectable: false,
    showRowHover: true,
    columns: [],
    data: [],
    count: 0,
    page: 0,
    showCheckboxes: false,
    // showHeaderToolbar: true,
    rowsPerPage: TABLE_LIMIT,
    rowsPerPageOptions: [],
  },
  PRODUCT_TAGS: ["VEG", "VEGAN", "GLUTEN FREE", "DIARY"],
  CURRENCY: "RS.",
  GENERAL_STATUS: {
    PENDING: "PENDING",
    WAITING: "WAITING",
    ACCEPTED: "ACCEPTED",
    ACTIVE: "ACTIVE",
    SUSPENDED: "SUSPENDED",
    ALLOTTED: "ALLOTTED",
    COMPLETED: "COMPLETED",
  },
  PMS_4B_BATCH_STATUS: {
    PENDING: "PENDING",
    PANEL_SET: "PANEL_SET",
    REVIEW_PENDING: "REVIEW_PENDING",
    REVIEW_SUBMITTED: "REVIEW_SUBMITTED",
  },
  PMS_BATCH_STATUS: {
    PENDING: "PENDING",
    REVIEW_PENDING: "REVIEW_PENDING",
    REVIEW_SUBMITTED: "REVIEW_SUBMITTED",
    NORMALIZATION_PENDING: "NORMALIZATION_PENDING",
    NORMALIZATION_DONE: "NORMALIZATION_DONE",
    HOD_REVIEW_PENDING: "HOD_REVIEW_PENDING",
    HOD_REVIEWED: "HOD_REVIEWED",
    AWARD_SHEET_DRAFTED: "AWARD_SHEET_DRAFTED",
    AWARD_SHEET_PENDING: "AWARD_SHEET_PENDING",
    AWARD_SHEET_APPROVED: "AWARD_SHEET_APPROVED",
    PMS_FINAL: "PMS_FINAL",
  },
  PMS_HOD_BATCH_STATUS: {
    NORMALIZED: "NORMALIZED",
    HOD_PENDING: "HOD_PENDING",
    HOD_SUBMITTED: "HOD_SUBMITTED",
  },
  PMS_OVERALL_HOD_BATCH_STATUS: {
    OVERALL_HOD_PENDING: "OVERALL_HOD_PENDING",
    OVERALL_HOD_REVIEW_PENDING: "OVERALL_HOD_REVIEW_PENDING",
    OVERALL_HOD_SUBMITTED: "OVERALL_HOD_SUBMITTED",
  },

  STATUS: {
    PENDING_VERIFICATION: "pending",
    PENDING_PENDING: "pending",
    PARTIAL_APPROVED: "pending_approval",
    "PARTIAL APPROVED":"pending_approval",
    PENDING: "pending",
    WAITING: "waiting",
    ACCEPTED: "warning",
    ACTIVE: "warning",
    INACTIVE: "error",
    WRITE_OFF: "error",
    "WRITE OFF": "error",
    SUSPENDED: "error",
    ALLOTTED: "success",
    COMPLETED: "success",
    RECEIVED: "success",
    Received: "success",
    "Partially Received": "success",
    Pending: "pending",
    TERMINATED: "error",
    CONFIRMED:"error",
    ABSCONDED: "error",
    RESIGNED: "error",
    EXPIRED: "success",
    REJECTED: "error",
    HOD_PENDING: "error",
    // PENDING:'pending',
    SOURCING: "error",
    NOSOURCING: "nosourcing",
    "CV Rejected": "error",
    "INTERVIEW REJECTED": "error",
    "Interview Rejected": "error",
    "PENDING REVIEW": "pending",
    "Pending Review": "pending",
    "CV SHORTLIST REJECTED": "error",
    DROPPED: "nosourcing",
    "AUTO REJECTED": "error",
    "Offer Declined": "error",
    "Not Joined": "error",
    Active: "error",
    "OFFER DECLINED": "error",
    "CV REJECTED": "error",
    "NOT JOINING": "error",
    Dropped: "nosourcing",
    "Feedback Pending": "pending",
    "REVIEW PENDING": "error",
    "PANEL SET": "success",
    SUBMITTED: "success",
    NORMALIZED: "success",
    HOD_SUBMITTED: "success",
    "HOD PENDING": "error",
    "NORMALIZATION DONE": "success",
    "HOD REVIEW PENDING": "error",
    SHORTLISTED: "success",
    "OVERALL HOD PENDING": "success",
    "OVERALL HOD REVIEW PENDING": "error",
    POSITIVE: "positiveBg",
    NEGATIVE: "errorBg",
    NEUTRAL: "neutralBg",
    "INCREMENT FROZEN": "success",
    PAID: "online",
    "ON PROBATION":"neutralBg",
    CONTINUED:"confirmedBg",
    "EXTENDED PROBATION":"extend",
    "NOT ELIGIBLE": "notEligible",
    "NOT QUALIFIED": "notQualified",
    NA: "notQualified",
    PROCESSED: "processed",
    CAPPED: "capped",
    FAILED: "notEligible",
    "UNABLE TO VERIFY": "pending_approval",
    CREATED: "pending_approval",
    UPDATED: "success",
    INCOMPLETE: "notEligible",
    COMPLETED: "success",
    INITIATED: "success",
    ACTIONED: "actioned"
  },
  JOB_OPENING_STATUS: {
    ACTIVE: "ACTIVE",
    CLOSED: "CLOSED",
  },
  VACANCY_TYPE: {
    RAP: "RAP",
    ADDITIONAL_REQUIREMENT: "ADDITIONAL_REQUIREMENT",
  },
  OFFER_LETTER_STATUS: {
    WAITING: "WAITING",
    DRAFTED: "DRAFTED",
    APPROVAL_DUE: "APPROVAL_DUE",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    PENDING: "PENDING",
    SENT: "SENT",
    ACCEPTED: "ACCEPTED",
    EXPIRED: "EXPIRED",
    DROPPED: "DROPPED",
    ON_HOLD: "ON_HOLD",
    HR_APPROVAL_PENDING: "HR_APPROVAL_PENDING",
    HR_REJECTED: "HR_REJECTED",
    HR_APPROVED: "HR_APPROVED",
    PENDING_APPROVAL: "PENDING_APPROVAL",
  },
  STATES: [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ],
  BANKS: {
  "allahabad_bank": "Allahabad Bank",
  "andhra_pradesh_grameena_vikas_bank": "Andhra Pradesh Grameena Vikas Bank",
  "andhra_pragathi_grameena_bank": "Andhra Pragathi Grameena Bank",
  "arunachal_pradesh_rural_bank": "Arunachal Pradesh Rural Bank",
  "aryavart_bank": "Aryavart Bank",
  "assam_gramin_vikash_bank": "Assam Gramin Vikash Bank",
  "au_small_finance_bank": "AU Small Finance Bank",
  "axis_bank": "Axis Bank",
  "bandhan_bank": "Bandhan Bank",
  "bangiya_gramin_vikash_bank": "Bangiya Gramin Vikash Bank",
  "bank_of_baroda": "Bank of Baroda",
  "bank_of_india": "Bank of India",
  "bank_of_maharashtra": "Bank of Maharashtra",
  "baroda_gujarat_gramin_bank": "Baroda Gujarat Gramin Bank",
  "baroda_rajasthan_kshetriya_gramin_bank": "Baroda Rajasthan Kshetriya Gramin Bank",
  "baroda_up_bank": "Baroda UP Bank",
  "canara_bank": "Canara Bank",
  "capital_small_finance_bank": "Capital Small Finance Bank",
  "central_bank_of_india": "Central Bank of India",
  "chaitanya_godavari_gramin_bank": "Chaitanya Godavari Gramin Bank",
  "chhattisgarh_rajya_gramin_bank": "Chhattisgarh Rajya Gramin Bank",
  "city_union_bank": "City Union Bank",
  "csb_bank": "CSB Bank",
  "dakshin_bihar_gramin_bank": "Dakshin Bihar Gramin Bank",
  "dcb_bank": "DCB Bank",
  "dhanlaxmi_bank": "Dhanlaxmi Bank",
  "ellaquai_dehati_bank": "Ellaquai Dehati Bank",
  "equitas_small_finance_bank": "Equitas Small Finance Bank",
  "esaf_small_finance_bank": "ESAF Small Finance Bank",
  "federal_bank": "Federal Bank",
  "fincare_small_finance_bank": "Fincare Small Finance Bank",
  "hdfc_bank": "HDFC Bank",
  "himachal_pradesh_gramin_bank": "Himachal Pradesh Gramin Bank",
  "icici_bank": "ICICI Bank",
  "idbi_bank": "IDBI Bank",
  "idfc_first_bank": "IDFC First Bank",
  "indian_bank": "Indian Bank",
  "indian_overseas_bank": "Indian Overseas Bank",
  "indusind_bank": "IndusInd Bank",
  "jammu_&_kashmir_bank": "Jammu & Kashmir Bank",
  "jammu_and_kashmir_grameen_bank": "Jammu And Kashmir Grameen Bank",
  "jana_small_finance_bank": "Jana Small Finance Bank",
  "jharkhand_rajya_gramin_bank": "Jharkhand Rajya Gramin Bank",
  "karnataka_bank": "Karnataka Bank",
  "karnataka_gramin_bank": "Karnataka Gramin Bank",
  "karnataka_vikas_grameena_bank": "Karnataka Vikas Grameena Bank",
  "karur_vysya_bank": "Karur Vysya Bank",
  "kerala_gramin_bank": "Kerala Gramin Bank",
  "kotak_mahindra_bank": "Kotak Mahindra Bank",
  "madhya_pradesh_gramin_bank": "Madhya Pradesh Gramin Bank",
  "madhyanchal_gramin_bank": "Madhyanchal Gramin Bank",
  "maharashtra_gramin_bank": "Maharashtra Gramin Bank",
  "manipur_rural_bank": "Manipur Rural Bank",
  "meghalaya_rural_bank": "Meghalaya Rural Bank",
  "mizoram_rural_bank": "Mizoram Rural Bank",
  "nagaland_rural_bank": "Nagaland Rural Bank",
  "nainital_bank": "Nainital Bank",
  "north_east_small_finance_bank": "North East Small Finance Bank",
  "nsdl_payments_bank_limited": "NSDL Payments Bank Limited",
  "odisha_gramya_bank": "Odisha Gramya Bank",
  "paschim_banga_gramin_bank": "Paschim Banga Gramin Bank",
  "prathama_up_gramin_bank": "Prathama UP Gramin Bank",
  "puduvai_bharathiar_grama_bank": "Puduvai Bharathiar Grama Bank",
  "punjab_and_sind_bank": "Punjab and Sind Bank",
  "punjab_gramin_bank": "Punjab Gramin Bank",
  "punjab_national_bank": "Punjab National Bank",
  "rajasthan_marudhara_gramin_bank": "Rajasthan Marudhara Gramin Bank",
  "rbl_bank": "RBL Bank",
  "saptagiri_gramin_bank": "Saptagiri Gramin Bank",
  "sarva_haryana_gramin_bank": "Sarva Haryana Gramin Bank",
  "saurashtra_gramin_bank": "Saurashtra Gramin Bank",
  "south_indian_bank": "South Indian Bank",
  "state_bank_of_india": "State Bank of India",
  "suryoday_small_finance_bank": "Suryoday Small Finance Bank",
  "tamil_nadu_grama_bank": "Tamil Nadu Grama Bank",
  "tamilnad_mercantile_bank": "Tamilnad Mercantile Bank",
  "telangana_grameena_bank": "Telangana Grameena Bank",
  "tripura_gramin_bank": "Tripura Gramin Bank",
  "uco_bank": "UCO Bank",
  "ujjivan_small_finance_bank": "Ujjivan Small Finance Bank",
  "union_bank_of_india": "Union Bank of India",
  "utkal_grameen_bank": "Utkal Grameen Bank",
  "utkarsh_small_finance_bank": "Utkarsh Small Finance Bank",
  "uttar_bihar_gramin_bank": "Uttar Bihar Gramin Bank",
  "uttarakhand_gramin_bank": "Uttarakhand Gramin Bank",
  "uttarbanga_kshetriya_gramin_bank": "Uttarbanga Kshetriya Gramin Bank",
  "vidarbha_konkan_gramin_bank": "Vidarbha Konkan Gramin Bank",
  "yes_bank": "Yes Bank"
},
  MONTHS: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  SALES_ORDER_STATUS_COLOR: {
    ACTIVE: "success",
    PENDING: "pending_sales",
    CANCELLED: "cancelled",
    CONFIRMED: "confirmed",
    PROCESSING: "processing",
    PICKED: "picked",
    PACKED: "packed",
    ON_GOING: "on_going",
  },
  INTERVIEW_STATUS: {
    PENDING: "PENDING",
    ACTIVE: "ACTIVE",
    SCHEDULED: "SCHEDULED",
    REJECTED: "REJECTED",
    SHORTLISTED: "SHORTLISTED",
    FEEDBACK_PENDING: "FEEDBACK_PENDING",
    COMPLETED: "COMPLETED",
    INTERVIEW_COMPLETED: "INTERVIEW_COMPLETED",
    INTERVIEW_REJECTED: "INTERVIEW_REJECTED",
  },
  JOB_CANDIDATE_STATUS: {
    ACTIVE: "ACTIVE",
    REJECTED: "REJECTED",
    SHORTLISTED: "SHORTLISTED",
    INTERVIEW_ALIGNED: "INTERVIEW_ALIGNED",
    CV_SHORTLIST_REJECTED: "CV_SHORTLIST_REJECTED",
    PENDING_SHORTLIST: "PENDING_SHORTLIST",
    SELECTED: "SELECTED",
    PENDING: "PENDING",
    CV_SHORTLISTED: "CV_SHORTLISTED",
    PENDING_REVIEW: "PENDING_REVIEW",
    DROPPED: "DROPPED",
    OFFER_LETTER: "OFFER_LETTER",
    OFFER_DECLINED: "OFFER_DECLINED",
    JOINING: "JOINING",
    JOINED: "JOINED",
    UNDER_OFFER: "UNDER_OFFER",
  },
  INTERVIEW_STATUS_TEXT: {
    PENDING: "Pending",
    ACTIVE: "Active",
    SCHEDULED: "Scheduled",
    REJECTED: "Rejected",
    SHORTLISTED: "Shortlisted",
    FEEDBACK_PENDING: "Feedback Pending",
    COMPLETED: "Completed",
    INTERVIEW_COMPLETED: "Interview Completed",
    INTERVIEW_REJECTED: "Interview Rejected",
    SELECTED: "SELECTED",
  },
  JOB_CANDIDATE_STATUS_TEXT: {
    ACTIVE: "Active",
    REJECTED: "Rejected",
    SHORTLISTED: "Shortlisted",
    INTERVIEW_ALIGNED: "Interview Aligned",
    CV_SHORTLIST_REJECTED: "CV Rejected",
    PENDING_SHORTLIST: "Pending Shortlist",
    SELECTED: "Selected",
    PENDING: "Pending",
    CV_SHORTLISTED: "CV Shortlisted",
    PENDING_REVIEW: "Pending Review",
    INTERVIEW_REJECTED: "Interview Rejected",
    JOINING: "Joining",
    DROPPED: "Dropped",
    ON_HOLD: "On Hold",
    OFFER_LETTER: "Offer Letter",
    SHARED_OFFER: "Shared Offer",
    UNDER_OFFER: "Under Offer",
    OFFER_DECLINED: "Offer Declined",
    CV_REJECTED: "CV Rejected",
    NOT_JOINING: "Not Joined",
    JOINED: "Joined",
  },
  SOCKET_EVENTS: {
    NEW_ORDER: "COMPANY_NEW_ORDER",
    ORDER_UPDATE: "COMPANY_ORDER_UPDATE",
    ORDER_ACCEPTED: "ORDER_ACCEPTED",
    ORDER_ASSIGNED: "ORDER_ASSIGNED",
    ORDER_REJECTED: "ORDER_REJECTED",
    ORDER_ON_PICKUP_LOCATION: "ORDER_ON_PICKUP_LOCATION",
    ORDER_ON_WAY: "ORDER_ON_WAY",
    ORDER_ON_DROP_LOCATION: "ORDER_ON_DROP_LOCATION",
    ORDER_DELIVERED: "ORDER_DELIVERED",
    ORDER_LOCATION_UPDATE: "COMPANY_LOCATION_UPDATE",
    ORDER_DATA: "ORDER_DATA",
    COMPANY_DRIVER_ADD: "COMPANY_DRIVER_ADD",
    COMPANY_DRIVER_REMOVE: "COMPANY_DRIVER_REMOVE",
  },
  USER_TYPES: {
    CUSTOMER: "CUSTOMER",
    MANUFACTURE: "MANUFACTURER",
    BOTH: "BOTH",
  },
  TRANSFER_TYPE_TEXT: {
    SALES_ORDER: "Sales Order",
    SALES_EXCHANGE_ORDER: "Sales Exchange Order",
    STOCK_TRANSFER_NOTE: "Stock Transfer Note",
  },
  PRIORITY_TEXT: {
    HIGH: "Hot",
    MEDIUM: "Warm",
    LOW: "Cold ",
  },
  PRIORITY: {
    HIGH: "HIGH",
    MEDIUM: "MEDIUM",
    LOW: "LOW",
  },
  CONCERN_STATUS_TEXT: {
    TRANSACTION_FAILURE: "Transaction Failure",
    ORDER_DISPUTE: "Order Dispute",
    ACCOUNT_RELATED_ISSUE: "Account Related Issue",
    PARTNER_REQUEST: "Partner Request",
    MEDIA_QUERY: "Media Query",
    GENERAL_SUPPORT: "General Support",
    CAREER_OPPORTUNITY: "Career Opportunity",
    OTHER: "Other",
  },
  SUPPORT_STATUS: {
    PENDING: "PENDING",
    RESOLVED: "RESOLVED",
  },
  SUPPORT_STATUS_TEXT: {
    PENDING: "Pending",
    RESOLVED: "Resolved",
  },
  QUOTE_STATUS: {
    PENDING: "PENDING",
    ON_GOING: "ON_GOING",
    CONVERTED: "CONVERTED",
    JUNK: "JUNK",
    COMPLETED: "COMPLETED",
  },
  QUOTE_STATUS_TEXT: {
    PENDING: "Pending",
    ON_GOING: "On Going",
    CONVERTED: "Converted",
    JUNK: "Junk",
    COMPLETED: "Completed",
  },
  QUOTE_STATUS_COLOR: {
    PENDING: "pending",
    ON_GOING: "on_going",
    CONVERTED: "converted",
    JUNK: "junk",
    COMPLETED: "completed",
  },
  INDUSTRY_STATUS_TEXT: {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    PENDING: "COMING SOON",
  },
  LEAD_STATUS: {
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS",
    QUOTE_SENT: "QUOTE_SENT",
    ARCHIVED: "ARCHIVED",
  },
  LEAD_STATUS_COLOR: {
    PENDING: "pending",
    IN_CONTACT: "in_Contact",
    FOLLOWUP: "followup",
    CONTACT_IN_FUTURE: "contact_in_future",
    JUNK: "junk",
    SUCCESSFUL: "success",
    LOST: "lost",
    UNQUALIFIED: "unqualified",
    DUPLICATE: "duplicate",
  },
  LEAD_STATUS_TEXT: {
    PENDING: "Pending",
    IN_PROGRESS: "In Progress",
    QUOTE_SENT: "Quote Sent",
    ARCHIVED: "Archived",
  },
  LEAD_REQUEST_STATUS: {
    PENDING: "PENDING",
    IN_CONTACT: "IN_CONTACT",
    FOLLOWUP: "FOLLOWUP",
    CONTACT_IN_FUTURE: "CONTACT_IN_FUTURE",
    JUNK: "JUNK",
    SUCCESSFUL: "SUCCESSFUL",
    LOST: "LOST",
    UNQUALIFIED: "UNQUALIFIED",
    DUPLICATE: "DUPLICATE",
  },
  LEAD_REQUEST_STATUS_TEXT: {
    PENDING: "Pending",
    IN_CONTACT: "In Contact",
    FOLLOWUP: "Followup",
    CONTACT_IN_FUTURE: "Contact In Future",
    JUNK: "Junk",
    SUCCESSFUL: "Successful",
    LOST: "Lost",
    UNQUALIFIED: "Unqualified",
    DUPLICATE: "Duplicate",
  },
  VENDOR_STATUS: {
    PENDING: "PENDING",
    LEAD: "LEAD",
    ONBOARDED: "ONBOARDED",
    SUSPENDED: "SUSPENDED",
    CANCELLED: "CANCELLED",
  },
  VENDOR_STATUS_TEXT: {
    PENDING: "pending",
    LEAD: "lead",
    ONBOARDED: "onboarded",
    SUSPENDED: "suspended",
    CANCELLED: "cancelled",
  },
  ROLES: {
    ADMIN: "ADMIN",
    OTHERS: "OTHERS",
    CORPORATE_HR: "CORPORATE_HR",
    RECRUITER: "RECRUITER",
    GENERAL: "GENERAL",
    OLR: "OLR",
    ACCOUNTANT: "ACCOUNTANT",
    CORPORATE_REVIEWER: "CORPORATE_REVIEWER",
    PMS: "PMS",
    CASHIER: "CASHIER",
    HR: "HR",
    MD: "MD",
    CORPORATE_ACCOUNTANT:"CORPORATE_ACCOUNTANT",
    HR_CHANGE_APPROVER: "HR_CHANGE_APPROVER",
    CORPORATE_AUDIT_2:"CORPORATE_AUDIT_2",
    EXECUTIVE:"EXECUTIVE",
    CORPORATE_AUDITOR:"CORPORATE_AUDITOR",
    TAXATION:"TAXATION",
    SITE_HR: "SITE_HR",
    SALES:"SALES",
    SALES_MANAGER: "SALES_MANAGER",
    DEMOGRAPHICS:"DEMOGRAPHICS",
    CORPORATE_ACCOUNTS: "CORPORATE_ACCOUNTS",
    CORP_HR: "CORP_HR",
    EXPENSE_MANAGER: "EXPENSE_MANAGER",
    SALES_HR: "SALES_HR",
    SALES_CORPORATE_HR: "SALES_CORPORATE_HR",
    FNF_HR: "FNF_HR",
  },
  LOG_ENABLED: true,
  WARNING_ENABLED: true,
  ERROR_ENABLED: true,
  TYPE_OF_VACANCY: {
    RAP: "Request Against Position",
    ADDITIONAL_REQUIREMENT: "Additional Requirement",
    RAB: "Requirement Against Budget",
  },
  PLANNER_TYPES: {
    SELF: "SELF",
    PEERS: "PEERS",
    SUBORDINATES: "SUBORDINATES",
    SUPERVISORS: "SUPERVISORS",
  },
  MODULES: {
    MOB_HOME: "MOB.HOME",
    EMP_PROFILE: "EMP.PROFILE",
    EMP_DAHSBOARD: "EMP.DAHSBOARD",
    HR_DASHBOARD: "HR.DASHBOARD",
    HR_EMP_RECORD: "HR.EMP.RECORD",
    HR_EMP_PROFLE: "HR.EMP.PROFLE",
    HR_NEW_EMP: "HR.NEW.EMP",
    HR_EMP_CHANGE: "HR.EMP.CHANGE",
    HR_EMP_APPROVAL: "HR.EMP.APPROVAL",
    EMP_HRPOLICY: "EMP.HRPOLICY",
    EMP_HRCIRCULARS: "EMP.HRCIRCULARS",
    EMP_INDUCTION: "EMP.INDUCTION",
    EMP_KNOWLEDGE: "EMP.KNOWLEDGE",
    EMP_LMS: "EMP.LMS",
    EMP_HCM: "EMP.HCM",
    EMP_DRISHTI: "EMP.DRISHTI",
    EMP_DEEPAK: "EMP.DEEPAK",
    EMP_UTSAV: "EMP.UTSAV",
    EMP_UDESHYA: "EMP.UDESHYA",
    EMP_CLAIMS: "EMP.CLAIMS",
    EMP_IMPRESTLEDG: "EMP.IMPRESTLEDG",
    HR_IMPRESTAPPROVAL: "HR.IMPRESTAPPROVAL",
    HR_INTERVIEW: "HR.INTERVIEW",
    HR_CANDIDATE: "HR.CANDIDATE",
    EMP_TAP: "EMP.TAP",
    HR_IMPREST_LEDGER: "HR.IMPREST.LEDGER",
    HR_TAP_APPROVE: "HR.TAP.APPROVE",
    HR_CLAIM_APPROVE: "HR.CLAIM.APPROVE",
    HR_CAR_REPORT: "HR.CAR.REPORT",
    HR_CLAIM_REPORT: "HR.CLAIM.REPORT",
    HR_INTERVIEW_CLAIM: "HR.INTERVIEW.CLAIM",
    HR_LOAN_APPROVE: "HR.LOAN.APPROVE",
    HR_ONGOING_LOAN: "HR.ONGOING.LOAN",
    HR_REVIEW_CANDIDATE: "HR.REVIEW.CANDIDATE",
    HR_INTERVIEW_FEEDBACK: "HR.INTERVIEW.FEEDBACK",
    HR_CANDIDATE_PROFILE: "HR.CANDIDATE.PROFILE",
    HR_JOB_OPENING: "HR.JOB.OPENING",
    HR_JOB_DETAIL: "HR.JOB.DETAIL",
    HR_OLR_REVIEW: "HR.OLR.REVIEW",
    HR_OLR_DRAFT: "HR.OLR.DRAFT",
    HR_EMP_PLANNER: "HR.EMP.PLANNER",
    GLOSSARY: "GLOSSARY",
  },

  verificationRows : [
  {
    key: "is_education_verification",
    label: "Education",
    statusKey: "is_education_verification_status",
    remarkKey: "is_education_verification_remark",
  },
  {
    key: "is_first_employment_verification",
    label: "1st Employment",
    statusKey: "is_first_employment_verification_status",
    remarkKey: "is_first_employment_verification_remark",
  },
  {
    key: "is_second_employment_verification",
    label: "2nd Employment",
    statusKey: "is_second_employment_verification_status",
    remarkKey: "is_second_employment_verification_remark",
  },
  {
    key: "is_criminal_verification",
    label: "Criminal",
    statusKey: "is_criminal_verification_status",
    remarkKey: "is_criminal_verification_remark",
  },
]

};
